import { render, staticRenderFns } from "./DomainsRepos.vue?vue&type=template&id=60ecb7e6&"
import script from "./DomainsRepos.vue?vue&type=script&lang=js&"
export * from "./DomainsRepos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports